/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { PollResponse } from "~/feature/Poll/generated-types";
import { PollSubmitRequest } from "~/feature/Poll/generated-types";
import { PollsSubmitRequest } from "~/feature/Poll/generated-types";
import { MultiplePollsSubmitRequest } from "~/feature/Poll/generated-types";

export const pollServiceMeta: Meta<typeof pollService> = {
	globalPoll: ["GET", "/api/v1/poll/globalpoll"],
	poll: ["GET", "/api/v1/poll/poll"],
	submitPollAnswer: ["POST", "/api/v1/poll/answer"],
	submitPollAnswers: ["POST", "/api/v1/poll/answers"],
	submitMultiplePollAnswers: ["POST", "/api/v1/poll/save-multiple-poll-quiz-answers"],
	clearAllMemberVotes: ["GET", "/api/v1/poll/clearallmembervotes"],
	clearAllVotes: ["POST", "/api/v1/poll/clearallvotes"],
	clearAllVotesInPoll: ["POST", "/api/v1/poll/clearallvotesinpoll"],
};

// Feature.Poll.Controllers.ApiV1PollController
export const pollService = {
	async globalPoll() {
		return await http.fetch<undefined, undefined>(pollServiceMeta.globalPoll, {  });
	},
	async poll() {
		return await http.fetch<PollResponse, undefined>(pollServiceMeta.poll, {  });
	},
	async submitPollAnswer(body: PollSubmitRequest) {
		return await http.fetch<undefined, PollSubmitRequest>(pollServiceMeta.submitPollAnswer, { body });
	},
	async submitPollAnswers(body: PollsSubmitRequest) {
		return await http.fetch<undefined, PollsSubmitRequest>(pollServiceMeta.submitPollAnswers, { body });
	},
	async submitMultiplePollAnswers(body: MultiplePollsSubmitRequest) {
		return await http.fetch<undefined, MultiplePollsSubmitRequest>(pollServiceMeta.submitMultiplePollAnswers, { body });
	},
	async clearAllMemberVotes() {
		return await http.fetch<undefined, undefined>(pollServiceMeta.clearAllMemberVotes, {  });
	},
	async clearAllVotes() {
		return await http.fetch<undefined, undefined>(pollServiceMeta.clearAllVotes, {  });
	},
	async clearAllVotesInPoll() {
		return await http.fetch<undefined, undefined>(pollServiceMeta.clearAllVotesInPoll, {  });
	},
};
